// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookOfMindOptionsPanel__panel___Ryiik {
    position: absolute;
    right: 0;
    bottom: 100%;
    left: 0;
    z-index: 3;
    width: calc(100% - 4px);
    max-width: 520px;
    margin: 0 auto;
}

.BookOfMindOptionsPanel__footerPanel___AfbxU {
    position: static;
    z-index: 2;
    width: auto;
    max-width: none;
    margin: 0;
}

.BookOfMindOptionsPanel__footerActions___GysDo {
    position: absolute;
    bottom: 4px;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 6px;
    max-width: calc(100% - 72px);
}

.BookOfMindOptionsPanel__footerSpeech___AkVEs {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    max-width: 100%;
}

.BookOfMindOptionsPanel__footerSpeech___AkVEs > span {
    display: inline-flex;
    width: auto;
    margin: 0;
}

.BookOfMindOptionsPanel__footerSpeech___AkVEs > span > span {
    width: auto;
}

.BookOfMindOptionsPanel__footerPanel___AfbxU > a,
.BookOfMindOptionsPanel__footerPanel___AfbxU > button {
    display: inline-flex;
    align-items: center;
    gap: 0.45em;
    box-sizing: border-box;
    padding: 2px 8px;
    border: 1px solid rgba(143, 107, 55, 0.16);
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.035);
    color: rgba(235, 230, 211, 0.88);
    opacity: 0.74;
    line-height: 20px;
    text-align: left;
    text-shadow: none;
    transition: background 120ms ease, border-color 120ms ease, color 120ms ease;
}

.BookOfMindOptionsPanel__footerPanel___AfbxU > a:hover,
.BookOfMindOptionsPanel__footerPanel___AfbxU > button:hover {
    border-color: rgba(173, 139, 62, 0.34);
    background: rgba(173, 139, 62, 0.18);
    color: rgba(245, 226, 164, 0.98);
}

.BookOfMindOptionsPanel__footerPanel___AfbxU > a:active,
.BookOfMindOptionsPanel__footerPanel___AfbxU > button:active {
    border-color: rgba(143, 107, 55, 0.28);
    background: rgba(0, 0, 0, 0.3);
}

.BookOfMindOptionsPanel__footerPanel_open___hwEhI > a,
.BookOfMindOptionsPanel__footerPanel_open___hwEhI > button {
    border-color: rgba(173, 139, 62, 0.34);
    background: rgba(173, 139, 62, 0.18);
    color: rgba(245, 226, 164, 0.98);
    opacity: 1;
}

.BookOfMindOptionsPanel__contents___aCQMJ {
    margin: 7px 2px 2px;
    padding: 12px 14px;
    border: 1px solid rgba(173, 139, 62, 0.3);
    border-radius: 3px;
    background: radial-gradient(
            ellipse at 50% -18%,
            rgba(210, 171, 96, 0.16),
            transparent 48%
        ),
        linear-gradient(
            90deg,
            rgba(255, 220, 151, 0.035),
            transparent 18%,
            transparent 82%,
            rgba(0, 0, 0, 0.14)
        ),
        repeating-linear-gradient(
            0deg,
            rgba(255, 239, 190, 0.012) 0 1px,
            transparent 1px 4px
        ),
        linear-gradient(
            to bottom,
            rgb(45, 38, 24) 0%,
            rgb(36, 31, 21) 42%,
            rgb(28, 25, 18) 100%
        );
    box-shadow: inset 0 1px 0 rgba(225, 184, 101, 0.1),
        inset 0 0 26px rgba(0, 0, 0, 0.26),
        0 -16px 24px -12px rgba(0, 0, 0, 0.9),
        0 6px 14px -10px rgba(0, 0, 0, 0.72);
    color: rgba(235, 230, 211, 0.84);
    font-family: "Montaga";
    font-size: 14px;
    font-style: normal;
    text-align: left;
}

.BookOfMindOptionsPanel__heading___Zd1wF {
    display: flex;
    justify-content: space-between;
    margin: 8px 0 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(173, 139, 62, 0.2);
    color: rgba(217, 191, 114, 0.78);
    font-family: "Montaga";
    font-size: 12px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.BookOfMindOptionsPanel__count___R71TE {
    color: rgba(210, 205, 190, 0.48);
}

.BookOfMindOptionsPanel__node___SOUvS {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    overflow: hidden;
    padding: 5px 7px;
    border: 1px solid rgba(173, 139, 62, 0.24);
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.24);
    color: rgba(235, 230, 211, 0.88);
    font-family: "Montaga";
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.BookOfMindOptionsPanel__node___SOUvS > span {
    overflow: hidden;
    text-overflow: ellipsis;
}

.BookOfMindOptionsPanel__removeButton___hdPzX {
    flex: none;
    padding: 2px 4px;
    border: 0;
    background: transparent;
    color: rgba(210, 205, 190, 0.54);
    font-family: "Montaga";
    font-size: 11px;
}

.BookOfMindOptionsPanel__removeButton___hdPzX:not(:disabled):hover,
.BookOfMindOptionsPanel__removeButton___hdPzX:not(:disabled):focus {
    outline: none;
    color: #d9bf72;
}

.BookOfMindOptionsPanel__removeButton___hdPzX:disabled {
    cursor: default;
    opacity: 0.22;
}

.BookOfMindOptionsPanel__progressSection___LtQ3Y {
    margin-top: 8px;
    padding-top: 6px;
    border-top: 1px solid rgba(173, 139, 62, 0.2);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `BookOfMindOptionsPanel__panel___Ryiik`,
	"footerPanel": `BookOfMindOptionsPanel__footerPanel___AfbxU`,
	"footerActions": `BookOfMindOptionsPanel__footerActions___GysDo`,
	"footerSpeech": `BookOfMindOptionsPanel__footerSpeech___AkVEs`,
	"footerPanel_open": `BookOfMindOptionsPanel__footerPanel_open___hwEhI`,
	"contents": `BookOfMindOptionsPanel__contents___aCQMJ`,
	"heading": `BookOfMindOptionsPanel__heading___Zd1wF`,
	"count": `BookOfMindOptionsPanel__count___R71TE`,
	"node": `BookOfMindOptionsPanel__node___SOUvS`,
	"removeButton": `BookOfMindOptionsPanel__removeButton___hdPzX`,
	"progressSection": `BookOfMindOptionsPanel__progressSection___LtQ3Y`
};
module.exports = ___CSS_LOADER_EXPORT___;
